import { useEffect, useState } from 'react';
import { fetchPriceRounding } from '../api';
import { State } from '~/types';

type DataState =
  | {
      type: State.Loading;
    }
  | {
      type: State.Error;
    }
  | {
      type: State.Success;
      data: number;
    };

export const usePriceRounding = (totalPrice: number) => {
  const [state, setState] = useState<DataState>({ type: State.Loading });

  useEffect(() => {
    let current = true;
    (async () => {
      try {
        setState({ type: State.Loading });
        const { data } = await fetchPriceRounding(totalPrice);
        if (!current) return;
        setState({ type: State.Success, data: data.roundingAmount });
      } catch (_) {
        setState({ type: State.Error });
      }
    })();
    return () => {
      current = false;
    };
  }, [totalPrice]);

  return state;
};
